module.exports = __webpack_public_path__ + "img/Republic of the Congo.afbcd05e.svg";